(function (app) {
  $(document).ready(function () {

    app.UserPassword = function () {

      var _this = this;
      var nameSpace = 'UserPassword',
        context = '.page__password--container'
        ;

      /**
       *
       * @returns {*}
       */
      _this.sendResetEmail = function ($form) {
        $('[data-success-message]').addClass('d-none');
        $('[data-error-message]').addClass('d-none');
        var query = $.Deferred();
        var requestData = $form.serializeObject();
        var appTransport = app.transport();
        appTransport
          .setEvent('onSuccess', function (response) {
            if (_.isEmpty(response)) {
              app.flashMessenger('error', 'Empty response');
              return query.reject(response);
            } else {
              if (response.success == true) {
                $('[data-success-message]').removeClass('d-none');
                return query.resolve(response);
              } else {
                app.flashMessenger('error', response);
                return query.reject(response);
              }
            }
          })
          .setEvent('onError', function (error) {
            if (error.message['message'] = 'User not found.') {
              $('[data-error-message]').removeClass('d-none');
            } else {
              app.flashMessenger('error', error.code + ' :: ' + error.message.message);
            }

            return query.reject(error);
          })
          .setEvent('onComplete', function () {

          })
          .setRequestData(requestData);

        appTransport.post('/api/public/customer/send-reset-email');
        return query.promise();
      };


      /**
       *
       * @returns {*}
       */
      _this.resetPassword = function ($form) {
        $('[data-success-message]').addClass('d-none');
        $('[data-error-message]').addClass('d-none');
        var query = $.Deferred();
        var requestData = $form.serializeObject();
        var appTransport = app.transport();
        appTransport
          .setEvent('onSuccess', function (response) {
            if (_.isEmpty(response)) {
              app.flashMessenger('error', 'Empty response');
              return query.reject(response);
            } else {
              if (response.success == true) {
                $('[data-success-message]').removeClass('d-none').find('span').text(response.message);
                return query.resolve(response);
              } else {
                app.flashMessenger('error', response);
                return query.reject(response);
              }
            }
          })
          .setEvent('onError', function (error) {
            $('[data-error-message]').removeClass('d-none').text(error.message.message);
            return query.reject(error);
          })
          .setEvent('onComplete', function () {

          })
          .setRequestData(requestData);

        appTransport.post('/api/public/customer/reset-password');
        return query.promise();
      };

      return {
        init: function () {
          // Fetch all the forms we want to apply custom Bootstrap validation styles to
          var forms = $('form.needs-validation', $(context));
          // Loop over them and prevent submission
          var validation = Array.prototype.filter.call(forms, function (form) {
            form.addEventListener('submit', function (event) {
              if (form.checkValidity() === false) {
                event.preventDefault();
                event.stopPropagation();
              } else {
                event.preventDefault();
                var $button = $(form).find('button[type=submit]');
                $button.button('loading');
                var formName = $(form).attr('name');

                if (formName == 'password__email--form') {
                  $.when(_this.sendResetEmail($(form))).done(function () {
                    $button.button('reset');
                  }).fail(function () {
                    $button.button('reset');
                  });
                }

                if (formName == 'password__reset--form') {
                  $.when(_this.resetPassword($(form))).done(function () {
                    $button.button('reset');
                  }).fail(function () {
                    $button.button('reset');
                  });
                }
              }
              form.classList.add('was-validated');
            }, false);


            var $password = $(':input[name=password]', $(context))[0];
            var $confirmPassword = $(':input[name=confirm_password]', $(context))[0];

            if ($(':input[name=password]', $(context)).length) {
              _this.validatePassword = function () {
                if ($password.value != $confirmPassword.value) {
                  $confirmPassword.setCustomValidity("Passwords Don't Match");
                } else {
                  $confirmPassword.setCustomValidity('');
                }
              };

              $password.onchange = _this.validatePassword;
              $confirmPassword.onkeyup = _this.validatePassword;
            }
          });

        }
      }

    }

  });

})(PreBuilt);

